import { useInstance, nextTick } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
import { swap } from '../utils';
export function useDraggable(data) {
  var instance = useInstance();
  var draggingKey = useState(null);
  var originIndex;
  var originData;
  var draggingIndex;
  function onRowDragStart(e, tableRow) {
    draggingIndex = originIndex = tableRow.get('index');
    var key = tableRow.get('key');
    draggingKey.set(key);
    originData = data.value;
    instance.trigger('dragstart', {
      key: key,
      from: draggingIndex
    });
  }
  function onRowDragOver(e, tableRow) {
    e.preventDefault();
    e.stopPropagation();
    if (draggingKey.value === null) return;
    var newIndex = tableRow.get('index');
    if (newIndex === draggingIndex) return;
    // swap data
    var newData = swap(data.value, draggingIndex, newIndex);
    draggingIndex = newIndex;
    data.set(newData);
  }
  function onRowDragEnd(e, tableRow) {
    e.preventDefault();
    // revert to origin data, then set to new data to trigger animation
    var newData = data.value;
    data.set(originData);
    nextTick(function () {
      data.set(newData);
      draggingKey.set(null);
      instance.trigger('dragend', {
        key: tableRow.get('key'),
        from: originIndex,
        to: draggingIndex
      });
    });
  }
  return {
    onRowDragStart: onRowDragStart,
    onRowDragOver: onRowDragOver,
    onRowDragEnd: onRowDragEnd,
    draggingKey: draggingKey
  };
}